import WithScaling from './components/WithScaling';
import Image from './Image';

export default Object.assign(Image, { WithScaling });
